import { Tag } from 'antd';
import type { PluginCategory } from '@/api/types';
import { colors } from '@/theme/tokens';

// One consistent chip for a plugin's category, colored by the category's own
// stored hex (ai.PluginCategory.Color). Used by the catalog column, the tool
// detail drawer, and the agent grant drawer so a category looks the same
// everywhere. Falls back to a muted "Uncategorized" pill when unresolved.

export function CategoryChip({ category }: { category?: PluginCategory | null }) {
  if (!category) {
    return (
      <Tag style={{ fontSize: 11, color: colors.slate[500], borderStyle: 'dashed', marginInlineEnd: 0 }}>
        Uncategorized
      </Tag>
    );
  }
  const hex = category.color || colors.slate[500];
  return (
    // A soft tint of the category color rather than a solid fill — reads calmer
    // in a dense table and stays legible in both themes.
    <Tag
      style={{
        fontSize: 11,
        marginInlineEnd: 0,
        color: hex,
        background: `${hex}18`,
        border: `1px solid ${hex}55`,
      }}
    >
      {category.name}
    </Tag>
  );
}
